import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'vendor_name', label: 'Vendor' },
  { key: 'invoice_count', label: 'Invoices', align: 'right' },
  { key: 'total_invoiced', label: 'Total Invoiced', align: 'right', type: 'money' },
  { key: 'total_paid', label: 'Total Paid', align: 'right', type: 'money' },
  { key: 'avg_invoice', label: 'Avg Invoice', align: 'right', type: 'money' },
  { key: 'pct_of_spend', label: '% of Spend', align: 'right', type: 'percent' },
];

export function SpendAnalysisReport() {
  return (
    <ReportView
      title="Spend Analysis"
      description="Non-rejected vendor invoices grouped by vendor, with each vendor's share of total spend."
      endpoint="/reports/procurement/spend-analysis"
      columns={COLUMNS}
      filters={['dateRange']}
      defaultSort="total_invoiced"
      xlsx
    />
  );
}
